import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-emop-api-item',
  templateUrl: './emop-api-item.component.html',
  styleUrls: ['./emop-api-item.component.scss']
})
export class EmopApiItemComponent implements OnInit {
  /**
   * 标题
   */
  @Input() titleName: string;
  /**
   * 代码内容
   */
  @Input() code: string;
  codeVisible: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }
}
